import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Facebook Fill
 */

export default function FacebookFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path d="M15.117 16C15.6046 16 16 15.6046 16 15.1169V0.883071C16 0.395283 15.6047 0 15.117 0H0.883077C0.395286 0 0 0.395283 0 0.883071V15.1169C0 15.6045 0.395224 16 0.883077 16H15.117Z" />
      <path
        d="M11.0398 16V9.80392H13.1195L13.4309 7.3892H11.0398V5.84755C11.0398 5.14843 11.2339 4.67201 12.2364 4.67201L13.5151 4.67145V2.5117C13.294 2.48227 12.5349 2.41653 11.6518 2.41653C9.80827 2.41653 8.54611 3.54185 8.54611 5.60841V7.3892H6.46103V9.80392H8.54611V16H11.0398Z"
        fill="white"
      />
    </Icon>
  );
}
